import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import EmptyContent from '@/views/Layout/EmptyContent.vue';
import { evidenceFileType } from '@/config/dic';
import { formatProtocol } from '@/utils/index';

var EvidenceImage = /*#__PURE__*/function (_Vue) {
  _inherits(EvidenceImage, _Vue);

  var _super = _createSuper(EvidenceImage);

  function EvidenceImage() {
    var _this;

    _classCallCheck(this, EvidenceImage);

    _this = _super.call(this);
    _this.scale = 1;
    _this.typeCount = 2;
    return _this;
  }

  _createClass(EvidenceImage, [{
    key: "typeWatch",
    value: function typeWatch(newval, old) {
      this.getType(newval);
    }
  }, {
    key: "urlWatch",
    value: function urlWatch(newval, old) {
      this.getType(this.fileType);
    }
  }, {
    key: "showWatch",
    value: function showWatch(newval, old) {
      var video = this.$refs.imageVideo;

      if (!video) {
        return;
      }

      if (newval) {
        video.play();
      } else {
        video.pause();
      }
    }
  }, {
    key: "getType",
    value: function getType(type) {
      var reg = /\.[^\\.]+$/;
      var types = reg.exec(this.fileUrl);

      if (types) {
        type = type || types[0];
        var fileType = type.slice(1, type.length).toLowerCase();
        if (evidenceFileType.doc.split(',').indexOf(fileType) !== -1) this.typeCount = 0; // 文本文件
        else if (evidenceFileType.pdf.split(',').indexOf(fileType) !== -1) this.typeCount = 1; // pdf文件
          else if (evidenceFileType.image.split(',').indexOf(fileType) !== -1) this.typeCount = 2; // 图片文件
            else if (evidenceFileType.mp4.split(',').indexOf(fileType) !== -1) this.typeCount = 3; // 音频文件
              else if (evidenceFileType.rar.split(',').indexOf(fileType) !== -1) this.typeCount = 4; // 压缩文件
                else this.typeCount = 5;
      }
    }
  }, {
    key: "onZoom",
    value: function onZoom(opts) {
      this.scale = opts.scale;
    }
  }, {
    key: "zoomIn",
    value: function zoomIn(type) {
      this.$refs.view.$zoomIn();
    }
  }, {
    key: "zoomOut",
    value: function zoomOut(type) {
      this.$refs.view.$zoomOut();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.$refs.view.$resetView();
    }
  }, {
    key: "getFormatUrl",
    get: function get() {
      return formatProtocol(this.fileUrl);
    }
  }, {
    key: "wordUrl",
    get: function get() {
      // console.log('word base url :', this.getFormatUrl)
      // console.log('word url :', `https://view.officeapps.live.com/op/embed.aspx?src=${this.getFormatUrl}&wdStartOn=1&wdEmbedCode=0&wdPrint=0`)
      return "https://view.officeapps.live.com/op/embed.aspx?src=".concat(this.getFormatUrl, "&wdStartOn=1&wdEmbedCode=0&wdPrint=0");
    }
  }, {
    key: "pdfUrl",
    get: function get() {
      return "".concat(this.getFormatUrl, "#toolbar=0&navpanes=0&scrollbar=0");
    }
  }, {
    key: "defaultUrl",
    get: function get() {
      return require('@/assets/images/empty.png');
    }
  }]);

  return EvidenceImage;
}(Vue);

__decorate([Prop({
  type: String,
  required: true
})], EvidenceImage.prototype, "fileUrl", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], EvidenceImage.prototype, "show", void 0);

__decorate([Prop({
  type: String,
  default: function _default() {
    return '';
  }
})], EvidenceImage.prototype, "fileType", void 0);

__decorate([Watch('fileType')], EvidenceImage.prototype, "typeWatch", null);

__decorate([Watch('fileUrl')], EvidenceImage.prototype, "urlWatch", null);

__decorate([Watch('show')], EvidenceImage.prototype, "showWatch", null);

EvidenceImage = __decorate([Component({
  components: {
    EmptyContent: EmptyContent
  }
})], EvidenceImage);
export default EvidenceImage;